import PropTypes from 'prop-types';
import React from 'react';
import compose from '../hoc/compose';
import defaultSymbol from './PanelHelpIcon';
import displayNames from '../controls/displayNames';
import Button from '../controls/button/button';
var HelpButton = function HelpButton(_ref) {
  var automationId = _ref.automationId,
    getClassName = _ref.getClassName,
    dataHook = _ref.dataHook,
    onClick = _ref.onClick,
    symbol = _ref.symbol;
  return /*#__PURE__*/React.createElement(Button, {
    automationId: automationId,
    dataHook: dataHook,
    className: getClassName('btn-help btn-header help'),
    onClick: onClick
  }, symbol);
};
HelpButton.displayName = displayNames.HELP_BUTTON;
HelpButton.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Handles click event of the button */
  onClick: PropTypes.func,
  /** Set custom icon instead of the default one */
  symbol: PropTypes.element
};
HelpButton.defaultProps = {
  symbol: /*#__PURE__*/React.createElement(defaultSymbol)
};
export default compose(HelpButton);